<div class="report-preview-container" *transloco="let t">
  <div class="report-preview-header">
    <div class="report-preview-menu">
      <div class="report-preview-menu-item" (click)="switchResults()" [ngClass]="!showCompleted ? 'active' : ''">
        {{ t('support/inProgress') }}
      </div>
      <div
        *ngIf="childResultsCompleted?.length > 0"
        class="report-preview-menu-item"
        (click)="switchResults()"
        [ngClass]="showCompleted ? 'active' : ''"
      >
        {{ t('support/completed') }}
      </div>
    </div>
    <div *ngIf="childResults" @skeletonTransition class="report-preview-next">
      <div *ngIf="showCompleted; else unFinished" class="report-preview-next-button">
        <div [routerLink]="getChildListLink()">{{ t('shared/childList') }}</div>
        <div class="mt-1">
          <i [class]="icons.chevronRight" [routerLink]="getChildListLink()"></i>
        </div>
      </div>
      <ng-template #unFinished>
        <div class="report-preview-next-button">
          <a [target]="dadUrl.target" [href]="dadUrl.url">
            {{ t('shared/childList') }}
          </a>
          <a [target]="dadUrl.target" class="mt-1" [href]="dadUrl.url">
            <i [class]="icons.chevronRight"></i>
          </a>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="row m-0">
    <ng-container *ngIf="getResults(); else skeleton">
      <div class="card col-lg-3 col-md-6 col-12" *ngFor="let result of getResults()">
        <div class="child-name text-truncate d-flex align-items-center justify-content-center">
          {{ result.child.fullName }}
        </div>
        <div class="card-body">
          <div class="text-truncate mt-3" [ngbTooltip]="getChildGroupTooltip(result.child.groups)" container="body">
            <span class="badge me-1" *ngFor="let group of result.child.groups | slice : 0 : 3">
              {{ group.name }}
            </span>
            <span class="badge" *ngIf="result.child.groups.length > 3"> + </span>
          </div>
          <div class="card-date mt-5 mb-3">
            <isophi-simple-badge
              [title]="result.test.shortTitle"
              [fontSize]="0.8"
              [bgColor]="result.test.color"
              [ngbTooltip]="result.test.title"
              container="body"
            >
            </isophi-simple-badge>
            <span>{{ result.finishedAt | date }}</span>
          </div>
          <a *ngIf="showCompleted; else unFinished" class="btn btn-outline-dark" [routerLink]="getResultLink(result.uuid)">
            {{ t('support/viewEvaluation') }}
          </a>
          <ng-template #unFinished>
            <a
              class="btn btn-outline-dark"
              [target]="getContinueTestDadUrl(result.uuid, result.child.uuid).target"
              [href]="getContinueTestDadUrl(result.uuid, result.child.uuid).url"
            >
              {{ t('support/continueRecording') }}
            </a>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-template #skeleton>
    <div *ngFor="let i of [1, 2, 3, 4]" class="report-preview-item-skeleton" @skeletonTransition>
      <ngx-skeleton height="24px" margin="4px 0 4px 0"></ngx-skeleton>
      <ngx-skeleton height="20px" margin="0 0 4px 0"></ngx-skeleton>
      <ngx-skeleton height="16px" margin="0 0 30px 0" width="50%"></ngx-skeleton>
      <ngx-skeleton height="210px"></ngx-skeleton>
    </div>
  </ng-template>
</div>
